(() => {
  const root = document.querySelector('[data-ds-header]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const openButton = root.querySelector('[data-ds-menu-open]');
  openButton.addEventListener('click', () => {
    dialog.showModal();
    document.documentElement.classList.add('ds-head-menu-open');
  });
  root.querySelector('[data-ds-menu-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('ds-head-menu-open'); openButton.focus(); });
  root.querySelector('#ds-header-language').addEventListener('submit', event => {
    try { localStorage.setItem('userLanguage', event.submitter.value); } catch (_) {}
  });
  const input = root.querySelector('[data-ds-search]');
  const suggestions = root.querySelector('[data-ds-suggestions]');
  const results = root.querySelector('[data-ds-results]');
  let timer, controller;
  const close = () => { suggestions.hidden = true; };
  input.addEventListener('input', () => {
    clearTimeout(timer);
    if (controller) controller.abort();
    const term = input.value.trim();
    if (term.length < 2) { close(); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const arabic = root.dataset.locale.startsWith('ar');
        const url = new URL(arabic ? root.dataset.searchUrl : root.dataset.suggestUrl, window.location.origin);
        url.search = new URLSearchParams(arabic ? {q:term,type:'product',view:'ds-predictive','options[unavailable_products]':'hide'} : {q:term,'resources[type]':'product','resources[limit]':'4','resources[options][unavailable_products]':'hide'});
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) { close(); return; }
        const data = await response.json();
        if (input.value.trim() !== term) return;
        const products = data.resources?.results?.products || data.products || [];
        results.replaceChildren();
        products.forEach(product => {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = product.url;
          const imageUrl = typeof product.image === 'string' ? product.image : product.featured_image?.url;
          if (imageUrl) { const image = document.createElement('img'); image.src = imageUrl; image.alt = ''; image.width = 54; image.height = 54; link.append(image); }
          const text = document.createElement('span');
          text.textContent = product.title;
          const price = Number(product.price);
          if (product.price != null && Number.isFinite(price)) {
            const amount = document.createElement('strong');
            amount.textContent = new Intl.NumberFormat(root.dataset.locale, {style:'currency',currency:root.dataset.currency}).format(price);
            text.append(amount);
          }
          link.append(text); li.append(link); results.append(li);
        });
        suggestions.hidden = products.length === 0;
      } catch (_) { close(); }
    }, 250);
  });
  root.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  document.addEventListener('click', event => { if (!root.contains(event.target)) close(); });
  root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) close(); });
  const section = root.closest('.ds-header-section');
  const reserveHeight = () => {
    if (section && !root.classList.contains('is-compact')) {
      section.style.setProperty('--ds-header-expanded-height', Math.ceil(root.getBoundingClientRect().height) + 'px');
    }
  };
  reserveHeight();
  if ('ResizeObserver' in window) new ResizeObserver(reserveHeight).observe(root);
  let previous = Math.max(0, window.scrollY);
  let direction = 0;
  let travel = 0;
  window.addEventListener('scroll', () => {
    const current = Math.max(0, window.scrollY);
    const delta = current - previous;
    previous = current;
    if (root.contains(document.activeElement) || dialog.open) {
      travel = 0;
      direction = 0;
      return;
    }
    if (current <= 40) {
      root.classList.remove('is-compact');
      travel = 0;
      direction = 0;
      return;
    }
    if (Math.abs(delta) < 2) return;
    const nextDirection = Math.sign(delta);
    travel = nextDirection === direction ? travel + Math.abs(delta) : Math.abs(delta);
    direction = nextDirection;
    if (direction > 0 && current > 140 && travel >= 32) {
      reserveHeight();
      root.classList.add('is-compact');
      travel = 0;
    } else if (direction < 0 && travel >= 48) {
      root.classList.remove('is-compact');
      travel = 0;
    }
  }, {passive:true});
})();
